import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "@/content/ContentContext";

const ease = [0.22, 1, 0.36, 1];

export default function DealerCTA() {
  const content = useContent();
  const d = content.dealer;
  return (
    <section
      id="dealer"
      data-testid="dealer-section"
      className="bg-harvest text-forest"
    >
      <div className="mx-auto flex max-w-[1440px] flex-col gap-10 px-6 py-20 lg:flex-row lg:items-center lg:justify-between lg:px-12 lg:py-28">
        <div className="max-w-2xl">
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease }}
            className="text-xs uppercase tracking-[0.3em] text-forest/70"
          >
            {d.overline}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 0.1, ease }}
            data-testid="dealer-heading"
            className="mt-4 font-display text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl"
          >
            {d.headingA} <span className="italic">{d.headingAccent}</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 0.15, ease }}
            className="mt-6 max-w-xl text-sm leading-relaxed text-forest/80 sm:text-base"
          >
            {d.sub}
          </motion.p>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.2, ease }}
        >
          <Link
            to="/contact?interest=dealership"
            data-testid="dealer-apply-button"
            className="group inline-flex shrink-0 items-center gap-3 bg-forest px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-cream transition-colors duration-300 hover:bg-moss"
          >
            {d.cta}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
